// extracted by mini-css-extract-plugin
export default {"wrap":"tooltip-module_wrap_UfELH","icon":"tooltip-module_icon_izY6K"};